exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#selfservices[data-v-3f2c116c]{background-color:#fafafa}#hero[data-v-3f2c116c]{padding:2rem}#herosection[data-v-3f2c116c]{padding-bottom:2rem;background:linear-gradient(90deg,#fafafa,rgba(69,90,197,.8)),url(\"/dist/heroback.jpg\");background-repeat:no-repeat;background-color:#fff;background-size:cover;color:#444}.sectionheader[data-v-3f2c116c]{padding-left:1rem;margin-bottom:2rem;font-size:12px}.news[data-v-3f2c116c]{margin:0 1rem}.news li[data-v-3f2c116c]{width:520px;padding-right:14px;font-size:.9rem}@media screen and (max-width:800px){#herosection[data-v-3f2c116c]{display:none}}@media screen and (max-width:700px){.news img[data-v-3f2c116c]{width:91px}}#mainfooter[data-v-3f2c116c]{background-color:#fafafa;margin-top:2rem;padding:3rem 0;text-align:center;color:#777;font-size:.875rem}#mainfooter p[data-v-3f2c116c]{margin-bottom:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f2c116c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Home.vue
// module id = 630
// module chunks = 0